import { AppHealthResponse } from './types';

interface CacheEntry {
  data: AppHealthResponse;
  timestamp: number;
  ttl: number;
}

// In-memory cache store (singleton)
const cache = new Map<string, CacheEntry>();

const DEFAULT_TTL = 30 * 1000; // 30 seconds

export function setCachedHealth(key: string, data: AppHealthResponse, ttl: number = DEFAULT_TTL): void {
  cache.set(key, {
    data,
    timestamp: Date.now(),
    ttl,
  });
}

export function getCachedHealth(key: string): AppHealthResponse | null {
  const entry = cache.get(key);

  if (!entry) {
    return null;
  }

  const age = Date.now() - entry.timestamp;
  if (age > entry.ttl) {
    cache.delete(key);
    return null;
  }

  return entry.data;
}

export function clearCache(key?: string): void {
  if (key) {
    cache.delete(key);
  } else {
    cache.clear();
  }
}

export function getCacheInfo(): { size: number; keys: string[] } {
  return {
    size: cache.size,
    keys: Array.from(cache.keys()),
  };
}
